import React from 'react';
import MyEventContainer from '../../../Containers/UserContainer/MyEvent';

const MyEventScreen = () => {
  return <MyEventContainer />;
};

export default MyEventScreen;
